import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("title", null, "Juker", -1);
const _hoisted_3 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_HeadTag = _resolveComponent("HeadTag");
  const _component_router_view = _resolveComponent("router-view");
  const _component_NoticeInfoModal = _resolveComponent("NoticeInfoModal");
  const _component_ModalsContainer = _resolveComponent("ModalsContainer");
  const _component_Splash = _resolveComponent("Splash");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_HeadTag, null, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }), !$data.isLoading ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_router_view), _createVNode(_component_NoticeInfoModal), _createVNode(_component_ModalsContainer)])) : _createCommentVNode("", true), $data.isLoading ? (_openBlock(), _createBlock(_component_Splash, {
    key: 1
  })) : _createCommentVNode("", true)]);
}